import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "./../pages/dashboard/dashboard.js";
import IBDashboard from "../pages/dashboard/ibDashboard.js";
import MT5Admin from "../pages/pages/mt5/MT5Admin.js";
import MT5AdminDetails from "../pages/pages/mt5/CustomersGestorDetails.js";
import OpenPositions from "../pages/pages/openPositions/openPositions.js";
import PaymentsDetails from "../pages/pages/payments/paymentsDetails.js";
import Users from "../pages/pages/users/users.js";
import UsersDetails from "../pages/pages/users/usersDetails.js";
import Customer from "../pages/pages/customers/customers.js";
import CustomerDetails from "../pages/pages/customers/customerDetails.js";
import Reservations from "../pages/pages/reservations/reservations.js";
import ReservationsDetails from "../pages/pages/reservations/reservationsDetails.js";
import Symbols from "../pages/pages/symbols/symbols.js";
import SymbolsDetails from "../pages/pages/symbols/symbolsDetails.js";
import Products from "../pages/pages/products/products.js";
import ProductsDetails from "../pages/pages/products/productsDetails.js";
import Rooms from "../pages/pages/rooms/rooms.js";
import RoomsDetails from "../pages/pages/rooms/roomsDetails.js";
import Deposits from "../pages/pages/deposits/deposits.js";
import DepositsDetails from "../pages/pages/deposits/depositsDetails.js";
import Positions from "../pages/pages/positions/positions.js";
import PositionsDetails from "../pages/pages/positions/positionsDetails.js";
import Payments from "../pages/pages/payments/payments.js";
import PaymentDetails from "../pages/pages/payments/paymentsDetails.js";
import Withdrawals from "../pages/pages/withdrawals/withdrawals.js";
import WithdrawalsDetails from "../pages/pages/withdrawals/withdrawalsDetails.js";
import Reports from "./../pages/pages/reports/reports.js";
import IBs from "./../pages/pages/ib/ibs.js";
import IBPurchases from "../pages/pages/purchases/ibPurchases.js";
import IBUsers from "../pages/pages/users/ibUsers.js";
import AppIbUsers from "../pages/pages/users/appIbUsers.js";
import AppIbUsersDetails from "../pages/pages/users/appIbUsersDetails.js";
import AppIBPurchases from "../pages/pages/purchases/appIbPurchases.js";
import AppIbPurchasesDetails from "../pages/pages/purchases/appIbPurchasesDetails.js";
import AppIbSignals from "../pages/pages/signals/appIbSignals.js";
import AppIbSignalsDetails from "../pages/pages/signals/appIbSignalsDetails.js";
import AppIbEvents from "../pages/pages/events/appIbEvents.js";
import AppIbEventsDetails from "../pages/pages/events/appIbEventsDetails.js";
import AppIBDashboard from "../pages/dashboard/appIbDashboard.js";
import PagesError from "./../pages/pages/error.js";
import LoginPage from "../auth/pages/LoginPage.jsx";
import ProtectedRoute from "../auth/components/ProtectedRoute.js";
import RegisterPage from "../auth/pages/RegisterPage.jsx";
import Settings from "../pages/pages/settings/settings.js";
import App from "../app.jsx";

const AppRoute = [
	{
		path: "",
		element: <App />,
		children: [
			{ path: "login", element: <LoginPage /> },
			{ path: "register", element: <RegisterPage /> },
			{ path: "/", element: <Navigate to="/login" /> },
			{
				path: "/*",
				element: <ProtectedRoute />,
				children: [
					{
						path: "dashboard",
						element: <Dashboard />,
					},
					{
						path: "ibDashboard",
						element: <IBDashboard />,
					},
					{
						path: "appIbDashboard",
						element: <AppIBDashboard />,
					},
					{
						path: "mt5Admin",
						element: <MT5Admin />,
					},
					{
						path: "customersGestorDetails",
						element: <MT5AdminDetails />,
					},
					{
						path: "users",
						element: <Users />,
					},

					{
						path: "customers",
						element: <Customer />,
					},
					{
						path: "customersDetails",
						element: <CustomerDetails />,
					},
					{
						path: "IBUsers",
						element: <IBUsers />,
					},
					{
						path: "appIbUsers",
						element: <AppIbUsers />,
					},
					{
						path: "usersDetails",
						element: <UsersDetails />,
					},
					{
						path: "appIbUsersDetails",
						element: <AppIbUsersDetails />,
					},
					{
						path: "appIbPurchases",
						element: <AppIBPurchases />,
					},
					{
						path: "appIbPurchasesDetails",
						element: <AppIbPurchasesDetails />,
					},
					{
						path: "reservations",
						element: <Reservations />,
					},
					{
						path: "reservationsDetails",
						element: <ReservationsDetails />,
					},
					{
						path: "symbols",
						element: <Symbols />,
					},
					{
						path: "symbolsDetails",
						element: <SymbolsDetails />,
					},
					{
						path: "products",
						element: <Products />,
					},
					{
						path: "productsDetails",
						element: <ProductsDetails />,
					},
					{
						path: "payments",
						element: <Payments />,
					},
					{
						path: "ibPurchases",
						element: <IBPurchases />,
					},
					{
						path: "appIbPurchases",
						element: <AppIBPurchases />,
					},
					{
						path: "paymentsDetails",
						element: <PaymentDetails />,
					},
					{
						path: "rooms",
						element: <Rooms />,
					},
					{
						path: "roomsDetails",
						element: <RoomsDetails />,
					},
					{
						path: "positions",
						element: <Positions />,
					},
					{
						path: "positionsDetails",
						element: <PositionsDetails />,
					},
					{
						path: "withdrawals",
						element: <Withdrawals />,
					},
					{
						path: "withdrawalsDetails",
						element: <WithdrawalsDetails />,
					},
					{
						path: "deposits",
						element: <Deposits />,
					},
					{
						path: "depositsDetails",
						element: <DepositsDetails />,
					},
					{
						path: "appIbSignals",
						element: <AppIbSignals />,
					},
					{
						path: "appIbSignalsDetails",
						element: <AppIbSignalsDetails />,
					},
					{
						path: "appIbEvents",
						element: <AppIbEvents />,
					},
					{
						path: "appIbEventsDetails",
						element: <AppIbEventsDetails />,
					},
					{
						path: "settings",
						element: <Settings />,
					},
					{ path: "ibs", element: <IBs /> },
					{ path: "reports", element: <Reports /> },
					{ path: "openPositions", element: <OpenPositions /> },
					{ path: "paymentsDetails", element: <PaymentsDetails /> },
					{ path: "*", element: <PagesError /> },
				],
			},
		],
	},
];

export default AppRoute;
